class JanusSuperUser {
  constructor(roomsArray) {
    const { Janus } = window;
    this.roomsArray = roomsArray;
    this.token = null;
    this.opaqueId = `npa-superuser-${Janus.randomString(12)}`;
    this.preAuctionAudioFile = '/var/www/html/NPAPreAuction.opus';
    this.pauseAuctionAudioFile = '/var/www/html/NPAPauseAuction.opus';
    this.postAuctionAudioFile = '/var/www/html/NPAPostAuction.opus';
    this.mixers = {};
    this.webrtcUp = {};
    this.joined = {};

    this.Janus = Janus;
    this.janus = null;

    this.reconnectRetries = 1800; // Retries every 1 second for 30 minutes.
  }

  /** Connect to Janus Server */
    initialize = (server, token, iceServers) => new Promise((resolve, reject) => {
      const { start } = this;
      this.Janus.init({
        debug: 'all',
        callback() {
          // Add a control for each room

          // Add a dedicated control to do the same action on all rooms

          // Use a button to start the demo
          resolve(start(server, token, iceServers));
        },
      });
    });

    reconnect = (server, token, iceServers) => {
      this.initialize(server, token, iceServers);
    };

    /** Start the session using our token and endpoints */
    start = (server, token, iceServers) => new Promise((resolve, reject) => {
      const {
        Janus, roomsArray, mixers, connectToAudioBridge, reconnect, reconnectRetries,
      } = this;
      this.token = token;
      let reconnectCounter = 0;
      this.janus = new this.Janus(
        {
          server,
          token,
          iceServers,
          async success() {
            // Create a handle per room: it will make it
            // easier to join them all, when needed.
            try {
              for (const room of roomsArray) {
                // eslint-disable-next-line no-await-in-loop
                await connectToAudioBridge(room);
                reconnectCounter = 0;
              }
              resolve(mixers);
            } catch (error) {
              reject(error);
            }
          },
          error(error) {
            if (!error.includes('Unauthorized request (wrong or missing secret/token)')
                && reconnectCounter <= reconnectRetries) {
              setTimeout(() => {
                reconnect(server, token, iceServers);
                reconnectCounter += 1;
              }, 1000);
            }

            Janus.error(error);
            reject(error);
          },
          destroyed() {

          },
        },
      );
    });

    connectToAudioBridge = (room) => new Promise((resolve, reject) => {
      const {
        Janus, janus, token, opaqueId, mixers, webrtcUp, joined, roomsArray,
      } = this;

      if (mixers[room]) return;
      const thisroom = room.roomId;
      // Attach to AudioBridge plugin
      // console.log(`connecting to audio bridge room: ${thisroom}`);
      if (!janus) {
        // console.log('connecting to audio bridge > janus is null', janus);
        return;
      }

      janus.attach(
        {
          plugin: 'janus.plugin.audiobridge',
          token,
          opaqueId,
          success(pluginHandle) {
            mixers[thisroom] = pluginHandle;
            // console.log(`audiobridge attached ${thisroom}`);
            resolve(`audiobridge attached ${thisroom}`);
            Janus.log(`[AudioBridge][${thisroom}]  Plugin attached! (${mixers[thisroom].getPlugin()}, id=${mixers[thisroom].getId()})`);
            // We now have a handle for this room, unlock the related
            // buttons (for pre-recorded and live announcements)
            // checkDefaultMusic(thisroom);
            // checkGoodbyeAudio(thisroom);
            // $(`#speak${thisroom}`).removeAttr('disabled').click(function () {
            //   const id = parseInt($(this).attr('id').split('speak')[1]);
            //   joinRoom(id);
            // });
            // Check if we're done
            if (Object.keys(mixers).length === roomsArray.length) {
              // We have all handles, unlock the "all rooms" buttons

              /** init any events */
            }
            // Finally, check the muted state of each room to set the right buttons

            /** do something with this */
            // checkMuted();
          },
          error(error) {
            Janus.error(`[AudioBridge][${thisroom}]    -- Error attaching plugin...`, error);
            reject(error.message);
            console.error(`Error attaching plugin... ${error.message}`);
          },
          consentDialog(on) {
            Janus.debug(`[AudioBridge][${thisroom}]  Consent dialog should be ${on ? 'on' : 'off'} now`);
            if (on) {
              // Darken screen and show hint

            } else {
              // Restore screen

            }
          },
          webrtcState(on) {
            Janus.log(`[AudioBridge][${thisroom}]  Janus says our WebRTC PeerConnection is ${on ? 'up' : 'down'} now`);
            if (!on) {
              delete webrtcUp[thisroom];
              return;
            }
            webrtcUp[thisroom] = true;
            // The WebRTC PeerConnection is on, which means we can now
            // speak to this room. Change the button to allow the superuser
            // to leave the room, hangup the call and so stop speaking
          },
          onmessage(msg, jsep) {
            Janus.debug(`[AudioBridge][${thisroom}]   ::: Got a message :::`, msg);
            const event = msg.audiobridge;
            Janus.debug(`[AudioBridge][${thisroom}]  Event: ${event}`);
            if (event) {
              if (event === 'joined') {
                // Successfully joined, create the audio WebRTC PeerConnection now
                if (msg.id) {
                  Janus.log(`[AudioBridge][${thisroom}]  Successfully joined room ${msg.room} with ID ${msg.id}`);
                  if (!joined[thisroom]) {
                    joined[thisroom] = true;
                    // Publish our stream
                    mixers[thisroom].createOffer(
                      {
                        media: { video: false }, // This is an audio-only stream
                        success(jsep) {
                          Janus.debug(`[AudioBridge][${thisroom}]  Got SDP!`, jsep);
                          const publish = {
                            request: 'configure',
                            muted: false,
                          };
                          mixers[thisroom].send({ message: publish, jsep });
                        },
                        error(error) {
                          Janus.error(`[AudioBridge][${thisroom}]  WebRTC error:`, error);
                          reject(error.message);
                          console.error(`WebRTC error... ${error.message}`);
                        },
                      },
                    );
                  }
                }
              } else if (event === 'destroyed') {
                // The room has been destroyed
                Janus.warn(`[AudioBridge][${thisroom}]  The room has been destroyed!`);
                console.error('The AudioBridge room has been destroyed');
              }
            }
            if (jsep) {
              Janus.debug(`[AudioBridge][${thisroom}]  Handling SDP as well...`, jsep);
              mixers[thisroom].handleRemoteJsep({ jsep });
            }
          },
          onlocalstream(stream) {
            Janus.debug(`[AudioBridge][${thisroom}]   ::: Got a local stream :::`, stream);
            // We're not going to attach the local audio stream,
            // we don't want to listen back to ourselves
          },
          onremotestream(stream) {
            // We don't care about the remote audio, we only connect
            // to the audio stream to play our own announcements
          },
          oncleanup() {
            Janus.log(`[AudioBridge][${thisroom}]   ::: Got a cleanup notification :::`);
            delete joined[thisroom];
            delete webrtcUp[thisroom];
            // The WebRTC PeerConnection is down, which means we're not
            // speaking to this room anymore. Change the button to allow
            // the superuser to join the room again and start speaking.
          },
        },
      );
    });

  /** Audio actions */
  playAudioFile = (room, mixer, action) => new Promise((resolve, reject) => {
    const {
      preAuctionAudioFile, pauseAuctionAudioFile, postAuctionAudioFile,
    } = this;

    function fileToPlay() {
      if (action === 'preAuctionAudio') {
        return {
          filename: preAuctionAudioFile,
        };
      }

      if (action === 'pauseAudio') {
        return {
          filename: pauseAuctionAudioFile,
        };
      }

      if (action === 'postAuctionAudio') {
        return {
          filename: postAuctionAudioFile,
        };
      }
    }

    const play = {
      request: 'play_file',
      room,
      secret: 'verysecret', // Secret of the room (that's why users shouldn't send this!)
      file_id: fileToPlay().filename.replace(/\//g, '_'), // We use a fixed ID: easier to stop later
      filename: fileToPlay().filename, // Path to the file to play: it must already be on the server
      loop: true, // Let's play it in a loop, until someone stops this
    };
    mixer.send({
      message: play,
      success(result) {
        if (result.error) {
          reject(result.error);
        }
        resolve();
        // Buttons are automatically updated by the timer
      },
    });
  });

  stopAudioFile = (room, mixer, action) => new Promise((resolve, reject) => {
    const {
      preAuctionAudioFile, pauseAuctionAudioFile, postAuctionAudioFile,
    } = this;
    function fileToPlay() {
      if (action === 'preAuctionAudio') {
        return {
          filename: preAuctionAudioFile,
        };
      }

      if (action === 'pauseAudio') {
        return {
          filename: pauseAuctionAudioFile,
        };
      }

      if (action === 'postAuctionAudio') {
        return {
          filename: postAuctionAudioFile,
        };
      }
    }

    const stop = {
      request: 'stop_file',
      room,
      secret: 'verysecret', // Secret of the room (that's why users shouldn't send this!)
      file_id: fileToPlay().filename.replace(/\//g, '_'), // We used a fixed ID, so we know what to stop
    };
    mixer.send({
      message: stop,
      success(result) {
        if (result.error) {
          reject(result.error);
        }
        resolve();
      },
    });
  });

    checkPreAuctionAudio = (room, mixer) => new Promise((resolve, reject) => {
      // Send a synchronous request to check the status of the playback
      const check = {
        request: 'is_playing',
        room,
        secret: 'verysecret', // Secret of the room (that's why users shouldn't send this!)
        file_id: 'preAuctionAudioFile', // This is the ID of the default music
      };
      return mixer.send({
        message: check,
        success(result) {
          if (result.error) {
            reject(result.error);
          }
          if (result.playing) {
            resolve(true);
          }
          // Music is NOT playing
          resolve(false);
        },
      });
    });

  checkAudioStatus = (room, mixer, id) => new Promise((resolve, reject) => {
    // Send a synchronous request to check the status of the playback
    const check = {
      request: 'is_playing',
      room,
      secret: 'verysecret', // Secret of the room (that's why users shouldn't send this!)
      file_id: id, // This is the ID of the default music
    };
    return mixer.send({
      message: check,
      success(result) {
        if (result.error) {
          reject(result.error);
        }
        if (result.playing) {
          resolve(true);
        }
        // Music is NOT playing
        resolve(false);
      },
      error(error) {
        reject(error);
      },
    });
  });

    /** Enable microphone and 'start speaking' */
    joinRoom = (room, mixer) => new Promise((resolve, reject) => {
      try {
        const join = {
          request: 'join',
          room,
          // secret: 'verysecret',	// Providing the secret, we join as admins
        };
        mixer.send({ message: join });
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });

    /** Stop speaking */
    leaveRoom = (room, mixer) => new Promise((resolve, reject) => {
      try {
        mixer.hangup(true);
        resolve(true);
      } catch (error) {
        reject(error);
      }
    })
}

export default JanusSuperUser;
